import React from 'react'
import Section from './Section'
import PostsSection from './PostsSection'
import ContactSection from './ContactSection'
import ImageSection from './ImageSection'
import Gelaende from './Gelaende'
import OfferSlider from './OfferSlider'
import TrainingTable from './TrainingTable'
import Grid from './Grid'
import Image from './Image'
import Lottie from './Lottie'

export function renderComponent(component, i) {
    const type = component.component

    if (type === undefined) {
        return component.children.map(renderComponent)
    }

    switch(type) {
        case "section":
            if (component.settings.class.indexOf('offer-slider-component') >= 0)
                return <OfferSlider key={i} {...component} />

            if (component.settings.class.indexOf('training-table-pkw') >= 0)
                return <TrainingTable key={i} {...component} vehicleType="pkw" />
                
            if (component.settings.class.indexOf('training-table-rettungskraefte') >= 0)
                return <TrainingTable key={i} {...component} vehicleType="rettungskraefte" />

            if (component.settings.class.indexOf('training-table-transporter') >= 0)
                return <TrainingTable key={i} {...component} vehicleType="ktp" />

            if (component.settings.class.indexOf('training-table-bus') >= 0)
                return <TrainingTable key={i} {...component} vehicleType="bus" />

            if (component.settings.class.indexOf('training-table-lkw') >= 0)
                return <TrainingTable key={i} {...component} vehicleType="lkw" />

            if (component.settings.class.indexOf('training-table-motorrad') >= 0)
                return <TrainingTable key={i} {...component} vehicleType="motorrad" />

            if (component.settings.class.indexOf('contact-section') >= 0)
                return <ContactSection {...component} key={i} />

            if (component.settings.class.indexOf('posts-section') >= 0)
                return <PostsSection {...component} key={i} />

            return <Section {...component} key={i} />

        case "heading":
            const Tag = component.settings.tag
            return <Tag className={component.settings.class} key={i}>{component.settings.text}</Tag>
        case "text":
            return <div key={i} className={"text " + component.settings.class} dangerouslySetInnerHTML={{__html: component.settings.text}}></div>
        case "html":
            if (component.settings.id === "gelaende") 
                return <Gelaende key={i} html={component.settings.html} />
            return <div key={i} className={"html " + component.settings.class} dangerouslySetInnerHTML={{__html: component.settings.html}}></div>
        case "grid":
            return <Grid key={i} {...component} />
        case "image":
            if (component.settings.class && component.settings.class.indexOf("lottie") >= 0) {
                return <Lottie key={i} {...component} />
            }

            if (component.settings.class && component.settings.class.indexOf("image-section") >= 0) {
                return <ImageSection key={i} {...component} />
            }

            return <Image key={i} {...component} />
        case "button":
            const className = component.settings.class || "btn";
            const href = component.settings.url;
            const target = className.indexOf('is-external') >= 0 ? '_blank' : undefined;
            return <a key={i} href={href} target={target} className={className}>{component.settings.text}</a>
        default:      
            console.log(component)     
            throw type
    }
}

const Layout = ({ content=[] }) => {


    return content && content.map(renderComponent)
}

export default Layout


// WEBPACK FOOTER //
// ./src/components/Layout.js